module.exports = __webpack_public_path__ + "static/media/legCurl.dc950c54.png";